import { useState } from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Massages from "@/components/Massages";
import Pricing from "@/components/Pricing";
import Gallery from "@/components/Gallery";
import Hours from "@/components/Hours";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import BookingModal from "@/components/BookingModal";

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);
  const closeBooking = () => setBookingOpen(false);

  return (
    <div className="App font-body" data-testid="app-root">
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <About />
        <Massages onBook={openBooking} />
        <Pricing onBook={openBooking} />
        <Gallery />
        <Hours />
        <Testimonials />
        <Contact onBook={openBooking} />
      </main>
      <Footer />
      <FloatingButtons />
      <BookingModal open={bookingOpen} onClose={closeBooking} />
    </div>
  );
}

export default App;
